import * as d3 from 'd3-selection'
import _series from './series'
import AnimationController from './animation-controller'
import * as array from 'd3-array'
import * as scale from 'd3-scale'
import types from '../../graph'

/*
 * Returns an object of all series, keyed by the id
 * and the value being the serie type
 */
const getSerieTypes = series => {
  let result = {}
  series.each(function (serie) {
    result[serie.id] = {
      type: d3.select(this).attr('data-serie-type'),
      serie: d3.select(this)
    }
  })
  return result
}

/*
 * Draws the graph portion of the plot. This is the plot's main content
 */
export default function (selection, chart, scalers) {
  selection.each(function (plotData) {
    let svg = d3.select(this.ownerSVGElement)
      , plot = d3.select(this)
      , chartData = chart.datum()
      , graph = plot.selectAll('.plot-graph')
                    .data(d => [d])
                    .enter()
                    .append('g')
                      .attr('class', 'plot-graph')
                      .attr('clip-path', plot => `url(#${svg.attr('id')}-chart-clip-path-plot-width-${plot.id})`)
                      .merge(plot.selectAll('.plot-graph'))
                      .transition()
                      .duration(chart.defaultTransition.duration())
      , prevSeries = graph.selection().selectAll('g.serie') // Capture the current state before the series are updated
      , prevSerieTypes = getSerieTypes(graph.selectAll('.serie'))

    graph.call(_series(prevSerieTypes)) // Make sure all series are in the DOM in the correct order

    // Build a set of all serie types. new + old + exiting
    let serieTypes = new Set(graph.selectAll('g.serie').nodes().map(node => node.dataset.serieType))

    serieTypes.forEach(type => {
      // Animate this group of series
      let allSeries = graph.selectAll(`g.serie.${type}`)
        , exitingSeries = allSeries.filter(function (serie) {
          return d3.select(this).classed('serie-exit')
        })
        , series = allSeries.filter(function (serie) {
          return !d3.select(this).classed('serie-exit') &&
            !d3.select(this).classed(`serie-prev-${type}`)
        })
        , extent = array.extent(series.selection().data(), serie => serie._columnIdx)
        , bandwidth = scalers.x.groupScale.bandwidth ? scalers.x.groupScale.bandwidth() : 0
        , serieScale = scale.scaleBand()
                            .domain(array.range(extent[0], extent[1] + 1))
                            .range([0, bandwidth])
                            .paddingInner(chartData.dimensions.padding.serie.inner)
                            .paddingOuter(chartData.dimensions.padding.serie.outer)
        , drawing = types[type]

      if (!drawing) {
        throw new Error(`Unsupported serie type: [${type}]`)
      }

      chart._graphTypes[type] = drawing

      let controller = new AnimationController(drawing, {
        chart,
        duration: graph.duration(),
        series, // All displayed series, excludes the series being removed
        exitingSeries,
        scalers,
        serieScale,
        plotId: plotData.id,
        previous: {
          allSerieTypes: prevSerieTypes, // Object the series in the previous chart
          serieOrder: graph.node()[`__${type}`] ? graph.node()[`__${type}`].serieOrder : [],
          series: prevSeries.filter(serie => serie.type == type)
        }
      })

      controller.animate(graph) // Animates the series for this chart type

      // Store previously used information on the plot container node
      // so entering exiting nodes can look up the values from the last draw
      graph.node()[`__${type}`] = {
        serieScale: serieScale,
        serieOrder: series.selection().data().map(serie => serie.id)
      }
    })

  })

}
